import { viewAudit } from 'common/constants/permissions';

const canViewAudit = permissions => !!permissions[viewAudit];

export default {
    canViewAudit
};
